import type { FC } from 'react';
import type { KeyValueDataObject } from '../KeyValueRow/KeyValueRow';
import { KeyValueRow } from '../KeyValueRow/KeyValueRow';
import classes from './FormDetails.module.scss';

interface FormDetailsProps {
    dataForShow: KeyValueDataObject[];
    title?: string;
    compact?: boolean;
}

/** Показывает подписанные сведения записи */
export const FormDetails: FC<FormDetailsProps> = (props) => {
    const { dataForShow, title, compact = false } = props;

    return (
        <div className={`${classes.container} ${compact
            ? classes.compact
            : ''}`}>
            {title &&
                <h3 className={classes.title}>{title}</h3>
            }
            <div className={classes.content}>
                {dataForShow.map((input, index) => (
                    <KeyValueRow
                        dataObject={input}
                        key={index}
                        compact={compact}
                        className={compact
                            ? classes.compactRow
                            : undefined
                        }
                    />
                ))}
            </div>
        </div>
    );
};
